module.exports = __webpack_public_path__ + "static/macbook_pro_retina@2x-361e035a14df7289d2c03e33650c0ada.png";